import { getValidToken } from '../utils/tokenUtils';

export const fetchTestersByOrganisation = async (organisationId) => {
  if (!organisationId) {
    return [];
  }

  const token = await getValidToken();
  const res = await fetch(`/api/users/organisation/${encodeURIComponent(organisationId)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(`Kunde inte hämta testare (${res.status}).` + (text ? ` - ${text}` : ''));
    err.status = res.status;
    throw err;
  }

  const data = await res.json();
  return Array.isArray(data) ? data : data.testers || [];
};
